import React from 'react';
import './Projects.css';

function Projects() {

  const projectsData = [
    {
      title: 'Print-IN 3D Creations',
      description: 'A storefront for browsing 3D printed products, viewing product details and managing a shopping cart, with a dedicated contact page.',
      contribution: 'Work focus: React storefront, product navigation and cart experience.',
      technologies: ['React', 'React Router', 'CSS', 'EmailJS'],
      github: 'https://github.com/harsh200539/printin3dcreations'
    },
    {
      title: 'Ledger — Expense Tracker',
      description: 'A personal finance app for tracking income and expenses, viewing monthly charts and reports, and importing bank statement CSV files with a review step.',
      contribution: 'Work focus: full-stack finance workflows, authentication and protected data access.',
      technologies: ['React', 'Express', 'Supabase', 'PostgreSQL', 'Chart.js'],
      github: 'https://github.com/harsh200539/expense-tracker'
    },
    {
      title: 'Orbit Watch Room',
      description: 'A small-group watch room with invite codes, voice chat, screen sharing and opt-in approximate location markers.',
      contribution: 'Work focus: peer-to-peer media, realtime room signaling and a Three.js entrance.',
      technologies: ['WebRTC', 'Supabase Realtime', 'Three.js', 'JavaScript'],
      github: 'https://github.com/harsh200539/orbit-watch-room'
    },
    {
      title: 'SignalDesk — NSE Watch',
      description: 'A family dashboard for following selected NSE companies and reviewing corporate filing evidence with source links and feed health.',
      contribution: 'Work focus: Next.js dashboard, scheduled feed ingestion and source-grounded analysis workflows.',
      technologies: ['Next.js', 'Supabase', 'TypeScript', 'NSE RSS'],
      github: 'https://github.com/harsh200539/signaldesk-nse-watch',
      note: 'Alerts and analysis require additional configuration.'
    },
    {
      title: 'SEO Atlas',
      description: 'A personal SEO review dashboard designed for multi-site HTML audits, saved findings and read-only Google Search Console reports.',
      contribution: 'Work focus: audit batches, scoped data access and Google Search Console integration.',
      technologies: ['Next.js', 'Supabase', 'Google Search Console', 'TypeScript'],
      note: 'Private project — deployment configuration in progress'
    },
    {
      title: 'Lexora — Internal Work Tracker',
      description: 'An internal task and reporting system for a legal practice, covering shared teams, assignments, reviews, deadlines and audit history.',
      contribution: 'Work focus: role-based workflows, team reporting and a documented audit trail.',
      technologies: ['React', 'TypeScript', 'Cloudflare Workers', 'D1'],
      note: 'Private project — details available on request'
    },
    {
      title: 'LINQ CRM — Event Booking System',
      description: 'An internal event booking and reporting system for conference operations. It organizes events, invoices, delegates, payment statuses and team access in one workflow.',
      contribution: 'Work focus: React interface, Django API, booking workflows and reporting.',
      technologies: ['React', 'Django', 'Python', 'CRM', 'Reporting'],
      note: 'Professional project — details available on request'
    },
    {
      title: 'LinguaLearn-AI',
      description: 'LinguaLearn-AI is a 3D AI-powered learning platform that delivers multilingual lessons with an interactive avatar teacher.',
      contribution: 'Explore the code for the avatar, lesson and multilingual experience.',
      technologies: ['HTML5', 'Tailwind CSS', 'Three.js', 'Node.js', 'Express.js', 'MongoDB', 'Socket.io', 'OpenAI API', 'Google Translate API', 'Ready Player Me API'],
      github: 'https://github.com/harsh200539/LinguaLearn-AI'
    },
    {
      title: 'SkillFlow AI',
      description: 'SkillFlow AI is a modern, full-stack application designed to provide an interactive platform for skills assessment, mentorship, and gamified learning. This project implements a high-fidelity frontend design originally created in Figma, backed by a robust Django API.',
      contribution: 'Work focus: translating a Figma design into a frontend backed by a Django API.',
      technologies: ['HTML5', 'Tailwind CSS',  'Node.js', 'Express.js', 'Django', 'Gemini API', 'Socket.io'],
      github: 'https://github.com/harsh200539/SkillFlow_AI'
    },
    {
      title: 'My Portfolio Website',
      description: 'A modern, immersive personal portfolio website built with React, featuring a space-themed design, interactive 3D/canvas animations, and a fully responsive layout.',
      contribution: 'Work focus: React components, visual design, animation and responsive layout.',
      technologies: ['React', 'CSS3', 'HTML5 Canvas', 'Bootstrap', 'AOS', 'EmailJS'],
      github: 'https://github.com/harsh200539/Portfolio-Website'
    }
    ,
    {
      title: 'Blue Panda Digital Marketing',
      description: 'A responsive digital marketing website with interactive 3D elements and a portfolio-style interface.',
      contribution: 'Work focus: React interface and interactive presentation.',
      technologies: ['React', 'React Router', 'Three.js', 'React Three Fiber', 'AOS', 'CSS'],
      live: 'https://bluepandadigitalmarketing.com/'
    }
    ,
    {
      title: 'CENT Banking Application',
      description: 'A Python banking-sector project exploring the use of face detection to help reduce fraudulent activity. The public repository contains the implementation.',
      contribution: 'Explore the repository for the scope and implementation.',
      technologies: ['Python', 'Face Detection', 'Banking'],
      github: 'https://github.com/harsh200539/CENT.........Face-Detection-Software-For-Banks'
    }
    
  ];

  return (
    <section id="projects" className="projects section">
      <div className="container">
        
        <div 
          className="sticky-header"
          data-aos="fade-up"
        >
          <h2 className="section-title">Featured Projects</h2>
          <p className="section-subtitle">
            A showcase of my recent work and achievements
          </p>
        </div>
        
        <div className="projects-grid">
          {projectsData.map((project) => (
            <div 
              key={project.title} 
              className={`project-card space-card`}
              data-aos="fade-up"
            >
              <div className="project-header">
                <h3>{project.title}</h3>
              </div>
              
              <p className="project-description">{project.description}</p>
              <p className="project-contribution">{project.contribution}</p>
              
              <div className="project-tech">
                {project.technologies.map(tech => (
                  <span key={tech} className="tech-tag">{tech}</span>
                ))}
              </div>
              
              <div className="project-links">
                {project.github && <a href={project.github} className="project-link" target="_blank" rel="noopener noreferrer" aria-label={`View ${project.title} on GitHub`}>
                  <span>GitHub</span><span className="arrow">→</span>
                </a>}
                {project.live && <a href={project.live} className="project-link" target="_blank" rel="noopener noreferrer" aria-label={`View ${project.title} live site`}>
                  <span>Live site</span><span className="arrow">→</span>
                </a>}
                {project.note && <span className="project-note">{project.note}</span>}
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default Projects;
